import styled from 'styled-components';

export const GoSafeImpWrap = styled.section`
    background: #fff2e5;
    border-radius: 0.6rem;
    padding: 2rem;
    margin-bottom: 1rem;
    margin-top:1.5rem;
    li {
        font-size: 1.4rem;
        padding-bottom: 0.5rem;
    }
`
export const GoSafeHeader = styled.p(
    props => `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 1rem;
    font-weight: bold;
    font-size: 1.6rem;
    color: #8e5a14;
    font-family: ${props.theme.font.fontFamily};
`
)
export const InfoIcon = styled.span`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #8e5a14;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 1.2rem;
    margin-right: 0.5rem;
`


